import { useCallback, useState } from 'react';
import { message } from 'antd';
import { usePreviewFormDiscardChangesMutation } from '../../../../api/expenseAreas';
import { AdminKickOffPreviewModal } from './AdminKickOffPreviewModal';
import { AdminScoreCardPreviewModal } from './AdminScoreCardPreviewModal';
import { AdminSupplierProfilePreviewModal } from './AdminSupplierProfilePreviewModal';

export type AdminPreviewFormType =
    | 'kick-off-questionnaire'
    | 'supplier-profile-questionnaire'
    | 'score-card';

export function useAdminFormPreview(formType: AdminPreviewFormType, expenseAreaId: string | number | undefined) {
    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewDiscardChanges, { isLoading: isOpeningPreview }] = usePreviewFormDiscardChangesMutation();

    const numericExpenseAreaId =
        expenseAreaId != null && expenseAreaId !== '' ? Number(expenseAreaId) : Number.NaN;

    const openPreview = useCallback(async () => {
        if (!Number.isFinite(numericExpenseAreaId)) {
            message.error('Expense area is not selected.');
            return;
        }

        try {
            await previewDiscardChanges({
                expense_area_id: numericExpenseAreaId,
                type: formType
            }).unwrap();
            setPreviewOpen(true);
        } catch (error: any) {
            message.error(error?.data?.message ?? 'Could not open preview.');
        }
    }, [formType, numericExpenseAreaId, previewDiscardChanges]);

    const previewModal =
        previewOpen && Number.isFinite(numericExpenseAreaId) ? (
            formType === 'kick-off-questionnaire' ? (
                <AdminKickOffPreviewModal
                    openModal={previewOpen}
                    setOpenModal={setPreviewOpen}
                    expenseAreaId={numericExpenseAreaId}
                />
            ) : formType === 'supplier-profile-questionnaire' ? (
                <AdminSupplierProfilePreviewModal
                    openModal={previewOpen}
                    setOpenModal={setPreviewOpen}
                    expenseAreaId={numericExpenseAreaId}
                />
            ) : (
                <AdminScoreCardPreviewModal
                    openModal={previewOpen}
                    setOpenModal={setPreviewOpen}
                    expenseAreaId={numericExpenseAreaId}
                />
            )
        ) : null;

    return { openPreview, isOpeningPreview, previewModal };
}
